import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { LayoutService } from "../../services/layouts/layout.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"],
})
export class SidemenuComponent implements OnInit, OnDestroy {
  menuDevelopment: any = [];
  logueado: boolean;
  Botones;
  Version: string;
  events: string[] = [];
  opened: boolean;
  modelo = [];
  submenuTitulo = "";
  layoutservices: LayoutService;
  translateData: any;
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private autentificador: AuthenticationService,
    private router: Router,
    private _ruta: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _layoutservices: LayoutService,
    private translator: Translator,
    private cdr: ChangeDetectorRef
  ) {
    this.layoutservices = _layoutservices;
  }

  ngOnInit(): void {
    this.translateData = this.translator.GetTranslations();

    // Escutar mudanças de idioma do backend
    this.translator.dataLanguage$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.translateData = this.translator.GetTranslations();
          this.cdr.detectChanges();
        }
      });

    if (!environment.production) {
      this.initializeDataListDevelopment();
    }

    // this.Version = environment.version;
    this.logueado = !this.autentificador.ocultarMenusQueryString(this._ruta);
    if (this.logueado) {
      // Configuración, Maestros e Taxonomia: 100% da API via getPermisosComoBotones()
      this.Botones = this.autentificador.getPermisosComoBotones();

      if (!Array.isArray(this.Botones)) {
        this.Botones = [];
      }

      // Maestros: injeção de "Control Accesos" (única manipulação pós-API, como exceção de negócio)
      this.injectAccessControlKuroiMenu();

      this.cdr.detectChanges();
    }

    this.layoutservices.urlclicked
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((u) => {
        if (u && u !== undefined) this.clicksubmenu(u);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private injectAccessControlKuroiMenu(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const maestrosSection = this.Botones.find((item) => {
      if (!Array.isArray(item?.submenu)) {
        return false;
      }
      const hasMaestrosRoute = item.submenu.some((submenuItem) =>
        (submenuItem?.route ?? "").toLowerCase().startsWith("/maestros/")
      );
      const isMaestrosLabel =
        item?.texto?.toLowerCase?.() === "maestros" ||
        item?.texto?.toLowerCase?.() ===
          (this.translateData?.Maestros?.toLowerCase?.() ?? "");
      return hasMaestrosRoute || isMaestrosLabel;
    });

    if (!maestrosSection || !Array.isArray(maestrosSection.submenu)) {
      return;
    }

    const alreadyExists = maestrosSection.submenu.some(
      (submenuItem) =>
        submenuItem?.route?.toLowerCase() ===
        "/maestros/accesos".toLowerCase()
    );

    if (!alreadyExists) {
      maestrosSection.submenu.push({
        texto:
          this.translateData?.ControlAccesos ?? this.translateData?.ControlAccesosKuroi ?? "Control Accesos",
        route: "/Maestros/Accesos",
      });
    }
  }

  async initializeTranslate() {
    let lang = this.translator.getLocale() || "es-ES";
    this.translateData = this.translator.GetTranslations();

    if (!localStorage.getItem("Language")) {
      localStorage.setItem("Language", lang);
    }
    if (localStorage.getItem("Language")) {
      lang = localStorage.getItem("Language");
    }

    this.translator.setLocale(lang);
    await this.translator.use(lang).then((data) => {
      if (data) {
        this.translateData = data;
      }
    });
  }

  initializeDataListDevelopment() {
    this.menuDevelopment = [
      {
        name: "Espacios",
        subMenu: [
          { name: "Espectáculos", route: "/Recintos/Espectaculos" },
          {
            name: "Sesiones con Butacas",
            route: "/Recintos/SesionesConButaca",
          },
        ],
      },
      {
        name: "Codigos Promocionales",
        subMenu: [
          {
            name: "CodigoPromocional",
            route: "/CodigosPromocionales/CodigoPromocional",
          },
          {
            name: "TipoCodigoPromocional",
            route: "/CodigosPromocionales/TipoCodigoPromocional",
          },
          {
            name: "CodigoPromocionalBines",
            route: "/CodigosPromocionales/CodigoPromocionalBines",
          }
        ],
      } /*
      {"name":"Clientes V11","subMenu":[
        {"name":"Cliente V11","route":"/Clientes/ClienteV11"},
        {"name":"Client Group V11","route":"/Clientes/GrupoClienteV11"},
        {"name":"Formas de Pago V11","route":"/Clientes/FormasPagoV11"}


      ]},
      {"name":"Maestros V11","subMenu":[
        {"name":"Type access control  V11","route":"/Maestros/TypeAccessControlV11"}

      ]},*/,
      {
        name: "Tarifas",
        subMenu: [
          {
            name: "Tipo Reserva",
            route: "/Tarifas/TipoReserva"
          },
          {
            name: "Temporadas Tarifas",
            route: "/Tarifas/TemporadaTarifas"
          },
          {
            name: "Grupos Tarifas",
            route: "/Tarifas/GruposTarifas"
          }
        ],
      },
      {
        name: "Tienda",
        subMenu: [
          {
            name: "Proveedores",
            route: "/tienda/Proveedores"
          },
          {
            name: "Productos",
            route: "/tienda/ProductosTienda"
          },
          {
            name: "Productos Promociones",
            route: "/tienda/ProductosPromociones"
          },
          {
            name: "Gestión de Inventario",
            route: "/tienda/gestioninventario"
          },
        ],
      },
      {
        name: 'Entradas y Promociones',
        subMenu: [
          {
            name: 'Reglas de negocio',
            route: '/EntradasPromociones/ReglasNegocio'
          }
        ]
      },
      {
        name: 'Maestros',
        subMenu: [
          {
            name: 'Jerarquía de Categorias',
            route: '/Maestros/CategoriasJerarquicas'
          },
          {
            name: 'Schemas',
            route: '/Maestros/schemas'
          }
        ]
      },
      {
        name: 'Configuración del proyecto',
        subMenu: [
          {
            name: 'Enlaces menú',
            route: '/configuracion/enlacemenu'
          },
           {
            name: 'Tipos de Usuarios',
            route: '/Usuario/TiposUsuarios'
          }
        ]
      }
    ];
  }

  clicksubmenu(ruta) {
    var allRoutes: string[] = [];

    for (var i = 0; i < this.router.config.length; i++) {
      allRoutes.push(this.router.config[i].path);
    }
    for (var i = 0; i < this.router.config[0].children.length; i++) {
      allRoutes.push(this.router.config[0].children[i].path);
      if (this.router.config[0].children[i].children) {
        for (
          var j = 0;
          j < this.router.config[0].children[i].children.length;
          j++
        ) {
          allRoutes.push(
            this.router.config[0].children[i].path +
              "/" +
              this.router.config[0].children[i].children[j].path
          );
        }
      }
    }

    if (allRoutes.find((x) => "/" + x == ruta)) {
      this.router.navigate([ruta]);
    } else {
      this.openSnackBar(this.translateData["Nodisponible"], this.translateData["Aceptar"]);
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2500,
      panelClass: ["blue-snackbar"],
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  private ensureMaestrosMenuEntries(): void {
    if (!this.Botones || !Array.isArray(this.Botones)) {
      return;
    }

    const maestrosSection = this.Botones.find(
      (menu) => (menu?.texto || "").toUpperCase() === "MAESTROS"
    );

    if (maestrosSection) {
      const controlAccesosKuroiEntry = {
        id: "maestros-control-accesos-kuroi",
        texto:
          this.translateData?.["Control Accesos"] ||
          "Control Accesos",
        icono: "security",
        route: "/Maestros/ControlAccesos",
      };

      const lugaresEntry = {
        id: "maestros-lugares",
        texto: this.translateData?.["Lugares"] || "Lugares",
        icono: "place",
        route: "/Maestros/Lugares",
      };

      const alreadyExistsKuroi =
        maestrosSection.submenu &&
        maestrosSection.submenu.some(
          (submenu) => submenu.route === controlAccesosKuroiEntry.route
        );

      if (!alreadyExistsKuroi) {
        maestrosSection.submenu = [
          ...(maestrosSection.submenu || []),
          controlAccesosKuroiEntry,
        ];
      }

      const alreadyExistsLugares =
        maestrosSection.submenu &&
        maestrosSection.submenu.some(
          (submenu) => submenu.route === lugaresEntry.route
        );

      if (!alreadyExistsLugares) {
        maestrosSection.submenu = [
          ...(maestrosSection.submenu || []),
          lugaresEntry,
        ];
      }
    }
  }

}
